import { Component } from '@angular/core';
import { CheckForUpdateService } from '@frontend/common/updater';
import { AppLoadingService } from './app-loading.service';

@Component({
  selector: 'db-app-root',
  template: `
    <frontend-app-loading *ngIf="appLoadingSrv.isLoading$ | async"></frontend-app-loading>
    <router-outlet></router-outlet>
  `,
  providers: [AppLoadingService],
  standalone: false
})
export class AppComponent {
  constructor(
    private updater: CheckForUpdateService,
    public appLoadingSrv: AppLoadingService
  ) {}
}
